export const messages = {
  "pt-BR": {
    remove: 'Excluir',
    save: 'Salvar',
    archive: 'Arquivar',
    edit: 'Editar',
    unarchive: 'Desarquivar',
    show: 'Visualizar',
    select: {
      noOptions: "Vazio",
      deselectLabel: "Remover",
      selectedLabel: "Selecionado",
      selectLabel: "Pressione enter para selecionar",
      placeholder: "Selecionar opção"
    },
    date: {
      month_names: [
        'Janeiro', 
        'Fevereiro', 
        'Março', 
        'Abril', 
        'Maio', 
        'Junho', 
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ],
      day_names: [
        'Domingo',
        'Segunda-feira',
        'Terça-feira',
        'Quarta-feira',
        'Quinta-feira',
        'Sexta-feira',
        'Sábado',
      ]
    }
  },
  en: {
    remove: 'Remove',
    save: 'Save',
    archive: 'Archive',
    unarchive: 'Unarchive',
    edit: 'Edit',
    show: 'Show',
    select: {
      noOptions: "Empty",
      deselectLabel: "Remove",
      selected: "Selected",
      selectLabel: "Press enter to select",
      placeholder: "Select option"
    },
    date: {
      month_names: [
        'January', 
        'February', 
        'March', 
        'April', 
        'May', 
        'June', 
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      day_names: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ]
    }
  }
}